'use client';
import type { FC } from 'react';
import { ImageWithPlaceholder } from '@/app/components/shared/ImageWithPlaceholder';
import { USER_BG } from '@/app/constants';
import { cn } from '@/app/utils';

interface CreatorAvatarProps {
  avatar?: string;
  nickname: string;
  className?: string;
}

const getColorIndex = (str: string) => str.charCodeAt(0) % USER_BG.length;

export const CreatorAvatar: FC<CreatorAvatarProps> = ({ avatar, nickname, className }) => {
  if (avatar) {
    return (
      <div className={cn('size-9 cursor-pointer overflow-hidden rounded-full', className)}>
        <ImageWithPlaceholder src={avatar} alt={nickname} />
      </div>
    );
  }
  return (
    <span
      className={cn(
        'inline-flex size-9 cursor-pointer items-center justify-center rounded-full text-system-white',
        className,
      )}
      style={{
        backgroundColor: USER_BG[getColorIndex(nickname)],
      }}
    >
      {nickname[0] + (nickname[1] ?? '')}
    </span>
  );
};
